import { RecoilRoot } from 'recoil'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'
import { urlInitializer } from 'src/layout/utils/routing'
import { LegacyParamsRewrite } from 'src/views/base/legacy-params-rewrite'
import { URLSync } from 'src/views/base/url-sync'

type RootProps = {
  children?: React.ReactNode
}

export const Root = (props: RootProps) => {
  const { router, query } = useParsedRouter()

  if (!router.isReady) {
    return null
  }
  return (
    <RecoilRoot initializeState={(snapshot) => urlInitializer(snapshot, query)}>
      <LegacyParamsRewrite />
      <URLSync />
      {props.children}
    </RecoilRoot>
  )
}
